import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";
import { getCurrentInstance } from "vue";

/**
 * Merge all classes and remove duplicates
 * NOTE: If this function is called inside a component, the component class in the attributes will also be merged.
 */
export function cn(...inputs: ClassValue[]) {
	let otherClasses: any = "";
	const instance = getCurrentInstance();

	if (instance != null) {
		otherClasses = instance.attrs.class ?? "";
	}

	return twMerge(clsx(inputs, otherClasses));
}

export function htmlBool(bool: unknown): true | undefined {
	if (typeof bool === "boolean" && bool) {
		return true;
	}

	return undefined;
}

/**
 * Set boolean to valid html attributes
 */
export function htmlAttrs(attrs: Record<any, any>): Record<string, string | true> {
	const out: Record<string, string> = {};

	for (const key in attrs) {
		const val = attrs[key];

		if (typeof val === "boolean" && val) {
			out[key] = "";
		} else if (typeof val !== "boolean") {
			out[key] = val;
		}
	}

	return out;
}

function interleave([x, ...xs]: readonly string[], ys: string[] = []): string[] {
	return x == null ? ys : [x.trim(), ...interleave(ys, xs)];
}

export const tw = (s: TemplateStringsArray, ...args: string[]) => interleave(s, args).join(" ");
